import { render, staticRenderFns } from "./presDelivery.vue?vue&type=template&id=2792cfb6&scoped=true&"
import script from "./presDelivery.vue?vue&type=script&lang=js&"
export * from "./presDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2792cfb6",
  null
  
)

export default component.exports